import CanInputEditorContainer from './CanInputEditorContainer'

export default CanInputEditorContainer
